import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import "@/plugins/index";
import commonJs from "@/commonJs";
import "@/styles/index.less"; // 全局通用样式
import "@/modules/newCommunity/assets/newCommunity.less"; // 全局通用样式
import h5Mixin from "@/modules/newCommunity/mixins/h5Mixin";
import emptyTable from "@/components/emptyTable/index.vue"; //列表无数据显示的组件
import VueVideoPlayer from "vue-video-player";
import "./commonJs/broadcastClue";
import { getTokenNew } from "@utils/userStorage";
import downCenterPlugins from "@wenwo-center-down/down-center";
import wenwoLoginModule from "@wenwo-center-pc/login-module";
import customEditor from "@/components/iwen/customEditor.vue";
// @ts-ignore
import InputDialogPlugin from "@/plugins/inputDialog/index.js";
Vue.use(InputDialogPlugin);
// @ts-ignore
import SurveyDialogPlugin from "@/plugins/surveyDialog/index.js";
Vue.use(SurveyDialogPlugin);

if (process.env.VUE_APP_MODE == "mock") {
  console.log("VUE_APP_MODEmock");
  const { mockXHR } = require("../mock/index.js");
  mockXHR();
}
Vue.use(wenwoLoginModule);
Vue.use(VueVideoPlayer);
// import compositionApi from "@vue/composition-api";
// @vueuse/core
// import $ from "jquery";
Vue.use(commonJs);
// Vue.use(compositionApi);
Vue.prototype.$EventBus = new Vue();
Vue.component("emptyTable", emptyTable);
import PageBlockItem from "@/components/PageBlockItem.vue";
Vue.component("PageBlockItem", PageBlockItem);
import ts from "@/components/ts.vue";
Vue.component("TS", ts);
Vue.component("customEditor", customEditor);
const options: any = {
  getToken: () => {
    return getTokenNew();
  },
};
Vue.use(downCenterPlugins, options);
Vue.config.productionTip = false;
if (process.env.NODE_ENV != "production") {
  Vue.config.devtools = true;
}
// Vue.config.devtools = true;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
